import React, { PropsWithChildren } from 'react';
import { ButtonGroup } from 'reactstrap';

const Container = ({ children }: PropsWithChildren<{}>) => (
  <div>
    <ButtonGroup className={'w-100'} vertical>
      {children}
    </ButtonGroup>
  </div>
);
export default Container;
